import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import {
	ApartmentOutlined,
	UsergroupAddOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

const OfficeTeamNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [menuItems, setMenuItems] = useState([]);

	useEffect(() => {
		setMenuItems([
			{
				key: "/member/manage-employee-teams",
				icon: <ApartmentOutlined />,
				label: "직원 팀 관리",
			},
			{
				key: "/member/assign-employee-team-members",
				icon: <UsergroupAddOutlined />,
				label: "팀별 멤버 지정",
			},
		]);
	}, []);

	const handleMenuClick = ({ key }) => {
		navigate(key);
	};

	const getSelectedKey = () => {
		const path =
			(location.pathname || "/").replace(/\/+$/, "") || "/";
		const found = menuItems.find((item) => item.key === path);
		if (found) {
			return found.key;
		}
		if (path.startsWith("/member/manage-employee-teams")) {
			return "/member/manage-employee-teams";
		}
		if (path.startsWith("/member/assign-employee-team-members")) {
			return "/member/assign-employee-team-members";
		}
		return "/member/manage-employee-teams";
	};

	return (
		<Sider
			width={250}
			className="member-navigation__sider"
			breakpoint="lg"
			collapsedWidth="0">
			<div className="member-navigation__logo">
				<ApartmentOutlined />
				<span>직원 팀</span>
			</div>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[getSelectedKey()]}
				items={menuItems}
				onClick={handleMenuClick}
				className="member-navigation__menu"
			/>
		</Sider>
	);
};

export default OfficeTeamNavigation;
